var userStr = localStorage.getItem("user");
if (userStr === "null" || userStr === "undefined" || userStr === "{}") {
  localStorage.removeItem("user");
  localStorage.removeItem("token");
}
